<div class="d-flex justify-content-center align-items-center h-100 flex-grow-1">
  <ngx-spinner [size]="'xl'"></ngx-spinner>
</div>
